import React from "react";
import { getDashboardView } from "./dashboardViews";
import DashboardSidebar from "./DashboardSidebar";

const DashboardShell = ({
  activeView,
  onViewChange,
  ga4Connected,
  children,
}) => {
  const view = getDashboardView(activeView);

  return (
    <div className="owner-dashboard__shell">
      <DashboardSidebar
        activeView={activeView}
        onChange={onViewChange}
        ga4Connected={ga4Connected}
      />
      <div className="owner-dashboard__main">
        <header className="owner-dashboard__view-header">
          <h2 className="owner-dashboard__view-title">{view.label}</h2>
          <p className="owner-dashboard__view-description">{view.description}</p>
          {view.source && (
            <span className="owner-dashboard__view-source">{view.source}</span>
          )}
        </header>
        <div className="owner-dashboard__view-content">{children}</div>
      </div>
    </div>
  );
};

export default DashboardShell;
